// import xhapp from '@scripts/lib/xhapp'
import { storage, splitHost, isAddGw } from './util'
import Vue from "vue";
import xha from '@xhtech/xhanalysis-sdk'
// import './directives/track'


const initMixin = {

  created() {
   
    const host = splitHost(location.host);
    console.log('host',host);
    // 埋点 sdk 初始化
    xha.init({
      appId: 'h5-mobile',
      api:
        env.env === 'production'
          ? '//sp.'+host+'/sp'
          : '//sptest.xiaohuaai.com/sp',
      env: env.env
    })

    xha.sdRegisterPage({
      appId: 'h5-mobile',
      clientVersion: '1.1'
    })
      


    /** customerid */
    let customerId = storage.get('customerId');
    if (!customerId) {
      let newUrl = isAddGw() ? '/gw/auth/user_info/h5' : '/auth/user_info/h5'
      Vue.http.post( newUrl , {})
      .then(res => res.json())
      .then(resp => {
        if (resp.um) {

          xha.sdLogin(resp.um)
          storage.set('customerId', resp.um)
        }
      })
    } else {

      xha.sdLogin(customerId)
    }
  },
  mounted() {
    let customerId = storage.get('customerId')
    console.log(customerId)
  }
}

export default initMixin



// WEBPACK FOOTER //
// ./web/js/common/initMixin.js